import { types } from "mobx-state-tree"

const Charger = types
  .model("Charger", {
    version: types.string,
    displayVersion: types.string,
  })
  .views((self) => {
    return {}
  })

export default Charger
